import { createSelector } from 'reselect';

const selectAgentStatus = (state: any) => state.agentStatus;

export const selectAgentStatusCurrentItem = createSelector([selectAgentStatus], (agentStatus) => agentStatus.current);

export const selectAgentStatusListItems = createSelector([selectAgentStatus], (agentStatus) => agentStatus.list);


export const selectAgentStatusItemById = (itemId: any) =>
    createSelector(selectAgentStatusListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAgentStatusCreatedItem = createSelector([selectAgentStatus], (agentStatus) => agentStatus.create);

export const selectAgentStatusUpdatedItem = createSelector([selectAgentStatus], (agentStatus) => agentStatus.update);

export const selectAgentStatusReadItem = createSelector([selectAgentStatus], (agentStatus) => agentStatus.read);

export const selectAgentStatusDeletedItem = createSelector([selectAgentStatus], (agentStatus) => agentStatus.delete);

export const selectAgentStatusSearchedItems = createSelector([selectAgentStatus], (agentStatus) => agentStatus.search);

export const selectAgentStatusItemsCount = createSelector([selectAgentStatus], (agentStatus) => agentStatus.count);

export const selectAgentStatusItemsFilter = createSelector([selectAgentStatus], (agentStatus) => agentStatus.filter);